import {Vue} from '../../../addiesaas'
import _ from 'lodash'

export default (components, options = {}) => {
  if (!_.isEmpty(components)) {
    _.forOwn(components, (item, itemName) => {
      const {namePrefix = '', nameSuffix = ''} = options
      itemName = namePrefix + itemName + nameSuffix
      Vue.component(item.name || _.kebabCase(itemName), item)
    })
  }
}
